import React, { useState } from "react";
import api from "../utils/Api";
import { Eye, EyeSlash } from "phosphor-react";
import { Toaster, toast } from "react-hot-toast";

const UpdatePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const updatePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    const token = localStorage.getItem("authToken");
    const fd = new FormData();
    fd.append("programType", "parentPasswordChange");
    fd.append("authToken", token);
    fd.append("oldPassword", oldPassword);
    fd.append("newPassword", newPassword);

   

    try {
      setLoading(true);
      const response = await api.post("parentApp/studentCurl2", fd);
      // console.log("Password Update Response:", response);
      if (response.data.success) {
        toast.success(response.data.data);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      console.error("Error updating password:", error);
      alert("Failed to update password.");
    } finally {
      setLoading(false);
    }
  };

  const renderPasswordInput = (label, value, setValue, show, setShow) => (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <div style={{ position: "relative" }}>
        <input
          type={show ? "text" : "password"}
          className="form-control pe-5"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          required
        />
        <span
          onClick={() => setShow(!show)}
          style={{
            position: "absolute",
            top: "50%",
            right: "12px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6c757d",
          }}
        >
          {show ? <EyeSlash size={20} /> : <Eye size={20} />}
        </span>
      </div>
    </div>
  );

  return (
    <div className="container" style={{ marginTop: "100px" }}>
      <Toaster position="top-center" /> {/* Add Toaster here */}
      <h4>Update Password</h4>
      <form onSubmit={updatePassword} className="mt-3">
        {renderPasswordInput(
          "Old Password",
          oldPassword,
          setOldPassword,
          showOld,
          setShowOld
        )}
        {renderPasswordInput(
          "New Password",
          newPassword,
          setNewPassword,
          showNew,
          setShowNew
        )}
        {renderPasswordInput(
          "Confirm New Password",
          confirmPassword,
          setConfirmPassword,
          showConfirm,
          setShowConfirm
        )}

        <button
          className="btn btn-primary w-100"
          type="submit"
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
    </div>
  );
};

export default UpdatePassword;
